import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import renderInlineSvg from '~/utils/renderInlineSvg';
import {Typography} from '@customink/pigment-react';

import './index.scss';

function renderImage(image, text) {
  if (typeof image === 'string') {
    return (
      <img
        alt={text}
        className="ndx-MenuButton-image"
        data-testid="MenuButton-image"
        src={image}
      />
    );
  } else {
    return image;
  }
}

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const MenuButton = props => {
  var itemClasses = classnames(
    'ndx-MenuButton',
    {isActionable: props.onClick, isDisabled: props.disabled},
    props.className
  );

  const renderIcon = () => {
    if (props.children) {
      return (
        <div className="ndx-MenuButton-icon" data-testid="MenuButton-icon">
          {props.children}
        </div>
      );
    } else if (props.icon) {
      return (
        <div
          className="ndx-MenuButton-icon"
          data-testid="MenuButton-icon"
          dangerouslySetInnerHTML={renderInlineSvg(props.icon)}
        />
      );
    } else {
      return (
        <div className="ndx-MenuButton-icon" data-testid="MenuButton-icon" />
      );
    }
  };

  const shouldRenderText = () => {
    return typeof props.text === 'object' || props.text.length;
  };

  return props.onClick || shouldRenderText() ? (
    <div
      className={itemClasses}
      role="button"
      onClick={props.disabled ? null : props.onClick}
      data-testid={props.text || 'MenuButton'}>
      {renderIcon()}
      {props.image ? renderImage(props.image, props.text) : null}
      {shouldRenderText() ? (
        <Typography
          variant="uiTextTiny"
          data-testid="MenuButton-text"
          className="ndx-MenuButton-text">
          {props.prependLabel?.length && (
            <span className="ndx-MenuButton-prependLabel">
              {props.prependLabel}{' '}
            </span>
          )}
          {props.text}
        </Typography>
      ) : null}
    </div>
  ) : (
    <div className={itemClasses} />
  );
};

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  prependLabel: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func
};

MenuButton.propTypes = propTypes;

MenuButton.defaultProps = {
  text: '',
  disabled: false,
  onClick: null
};

export default MenuButton;
